const property_CN_Locale = {
    'property.leftContent':'Copyright © 2024深圳度影医疗科技有限公司(RayShape)',
    'property.conterContent':'互联网药品信息服务资格证书[（粤）一非经营性—2024—0304]',
    'property.rightContent':'粤ICP备20014412号'
 }
export default property_CN_Locale
